module.exports = __webpack_public_path__ + "img/h_s1e1_gallery_3.4018b761.png";